import { PRERENDER_SERVICE_USER_AGENT } from './constants';

export const isPreRendering =
  navigator.userAgent === PRERENDER_SERVICE_USER_AGENT;
